import {
    battery,
    bubendorffMotorType,
    lastActivity,
    lastSeen,
    thermalControl,
} from '~/helpers/fields-description';
import { NAModule } from '~/models/modules/NAModule.model';

export class BubendorffModule extends NAModule {
    hasOperationReset = false;

    bubendorff_motor_type?: string;
    last_activity?: number;
    shutter_thermal_control_enabled?: boolean;

    isWired = false;

    get fieldBattery() {
        return battery(this.getBatteryIcon(this.battery_vp), this.battery_vp);
    }
    get fieldBubendorffMotorType() {
        return bubendorffMotorType(this.bubendorff_motor_type);
    }
    get fieldLastSeen() {
        return lastSeen(this.last_seen, this.outdatedLastSeen ? 'error--text' : '');
    }
    get fieldLastActivity() {
        return lastActivity(this.last_activity);
    }
    get fieldThermalControl() {
        if (this.shutter_thermal_control_enabled) {
            return thermalControl(this.shutter_thermal_control_enabled);
        }
    }
}
